import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { LayoutGrid, Truck, Wrench, Building2, Hammer, DollarSign, UserPlus, Tractor, Clock, X, PanelLeftClose, PanelLeft } from "lucide-react";

const LOGO = "https://customer-assets-agu9un31.emergentagent.net/job_truck-tracker-66/artifacts/7cv6lzz6_1.png";

const NAV = [
  { to: "/", label: "Dashboard", icon: LayoutGrid, end: true, testId: "nav-overview" },
  { to: "/trucking", label: "Trucking", icon: Truck, testId: "nav-trucking" },
  { to: "/fleet", label: "Fleet", icon: Wrench, testId: "nav-fleet" },
  { to: "/buildings", label: "Facilities", icon: Building2, testId: "nav-buildings" },
  { to: "/north-shop", label: "North Shop", icon: Hammer, testId: "nav-north-shop" },
  { to: "/units", label: "Units", icon: Tractor, testId: "nav-units" },
  { to: "/sales", label: "Recently Sold", icon: DollarSign, testId: "nav-sales" },
  { to: "/leads", label: "Leads", icon: UserPlus, testId: "nav-leads" },
];

const Clocktime = ({ collapsed }) => {
  const [now, setNow] = React.useState(new Date());
  React.useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(t);
  }, []);
  return (
    <div className={`px-5 py-4 border-t border-white/10 ${collapsed ? "lg:hidden" : ""}`}>
      <div className="flex items-center gap-2 text-white/50 text-xs uppercase tracking-widest font-bold">
        <Clock className="w-4 h-4" /> Live
      </div>
      <div data-testid="sidebar-clock" className="font-mono-data text-xl text-white mt-1 tracking-tighter">
        {now.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", second: "2-digit" })}
      </div>
      <div className="text-white/40 text-xs mt-1">
        {now.toLocaleDateString([], { weekday: "short", month: "short", day: "numeric" })}
      </div>
    </div>
  );
};

export default function Sidebar({ open = false, onClose = () => {} }) {
  const [collapsed, setCollapsed] = useState(() => localStorage.getItem("sb_collapsed") !== "0");
  const toggle = () =>
    setCollapsed((c) => {
      localStorage.setItem("sb_collapsed", c ? "0" : "1");
      return !c;
    });

  return (
    <>
      {open && (
        <div className="fixed inset-0 bg-black/50 z-40 lg:hidden" onClick={onClose} data-testid="sidebar-backdrop" />
      )}
      <aside
        data-testid="sidebar"
        className={`fixed lg:sticky top-0 left-0 z-50 w-64 ${collapsed ? "lg:w-16" : "lg:w-44"} shrink-0 bg-[#16265F] h-screen flex flex-col transition-[width,transform] duration-200 ${open ? "translate-x-0" : "-translate-x-full"} lg:translate-x-0`}
      >
        <div className="px-3 pt-4 pb-3 border-b border-white/10 relative flex items-center justify-between">
          <img src={LOGO} alt="Whipp Sales & Service" className={`w-full ${collapsed ? "lg:hidden" : ""}`} data-testid="sidebar-logo" />
          {collapsed && <span className="hidden lg:block w-full text-center font-head font-bold text-2xl text-white">W</span>}
          <button
            onClick={toggle}
            data-testid="sidebar-collapse-toggle"
            className="hidden lg:flex absolute top-2 right-2 text-white/60 hover:text-white p-1"
            title={collapsed ? "Expand sidebar" : "Minimize sidebar"}
          >
            {collapsed ? <PanelLeft className="w-5 h-5" /> : <PanelLeftClose className="w-5 h-5" />}
          </button>
          <button onClick={onClose} className="lg:hidden absolute top-3 right-3 text-white/70 hover:text-white" data-testid="sidebar-close">
            <X className="w-6 h-6" />
          </button>
        </div>
        <nav className="flex-1 py-3 overflow-y-auto">
          {NAV.map(({ to, label, icon: Icon, end, testId }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              data-testid={testId}
              onClick={onClose}
              title={collapsed ? label : undefined}
              className={({ isActive }) =>
                `flex items-center gap-3 px-4 py-3 text-sm font-medium transition-colors duration-200 border-l-4 ${collapsed ? "lg:justify-center lg:px-0 lg:gap-0" : ""} ${
                  isActive
                    ? "border-[#E0A81E] bg-white/10 text-white"
                    : "border-transparent text-white/60 hover:text-white hover:bg-white/5"
                }`
              }
            >
              <Icon className="w-5 h-5 shrink-0" />
              <span className={collapsed ? "lg:hidden" : ""}>{label}</span>
            </NavLink>
          ))}
        </nav>
        <Clocktime collapsed={collapsed} />
      </aside>
    </>
  );
}
